package com.appsyde.shared.modules.account.data.source

/** Statut du token pour la page de confirmation (GET). */
sealed class ConfirmDeletionStatusDto {
    data class Valid(val accountPrimaryEmail: String) : ConfirmDeletionStatusDto()
    data object Expired : ConfirmDeletionStatusDto()
    data object AlreadyUsed : ConfirmDeletionStatusDto()
    data object Invalid : ConfirmDeletionStatusDto()
}

/** Résultat du POST confirmation (exécution suppression). */
sealed class ConfirmDeletionResultDto {
    data object Deleted : ConfirmDeletionResultDto()
    data object InvalidOrExpired : ConfirmDeletionResultDto()
    data object AlreadyUsed : ConfirmDeletionResultDto()
}

interface ConfirmDeletionDataSource {
    suspend fun getStatus(token: String): ConfirmDeletionStatusDto
    suspend fun executeDeletion(token: String): ConfirmDeletionResultDto
}
